import * as React from 'react';
import NumberFormat from 'react-number-format';
import { TextField } from '@material-ui/core';

interface NumberFormatWrapperProps {
  readOnly: boolean;
  value?: string;
  autoFocus: boolean;
  onChange: (values: any) => void;
  inputRef: any;
  format: string;
  pattern: string;
  thousandSeparator: string;
  allowNegative: boolean;
  type: 'text' | 'tel' | 'password';
}

const NumberFormatWrapper = (props: NumberFormatWrapperProps) => {
  const { inputRef, onChange, format, pattern, thousandSeparator, allowNegative, readOnly = false, value, autoFocus = false, type, ...other } = props;

  const handleValueChange = (values: any) => {
    if (onChange && values) {
      onChange({ target: { value: values.value } });
    }
  };

  return (
    <NumberFormat
      required
      pattern={pattern}
      format={format}
      thousandSeparator={thousandSeparator}
      allowNegative={allowNegative}
      getInputRef={inputRef}
      onValueChange={handleValueChange}
      readOnly={readOnly}
      autoFocus={autoFocus}
      value={value}
      type={type}
      {...other}
    />
  );
};

interface NumberFormatInputProps {
  fullWidth?: boolean;
  disabled?: boolean;
  value?: string;
  startAdornment?: any;
  ref?: any;
  readOnly?: boolean;
  onKeyPress?: (event: any) => void;
  onKeyUp?: (event: any) => void;
  autoFocus?: boolean;
  type?: string;
  onChange?: (event: any) => void;
  onBlur?: (event: any) => void;
  InputProps?: any;
  format?: string;
  pattern?: string;
  thousandSeparator?: string;
  allowNegative?: boolean;
  error: any;
}

const NumberFormatInput = (props: NumberFormatInputProps) => {
  const {
    fullWidth = true,
    onChange,
    format,
    pattern,
    thousandSeparator,
    allowNegative,
    disabled = false,
    readOnly = false,
    value,
    startAdornment,
    ref,
    onKeyPress,
    onKeyUp,
    onBlur,
    autoFocus = false,
    type = 'text',
    InputProps,
    error,
    ...other
  } = props;
  return (
    <TextField
      fullWidth={fullWidth}
      variant='outlined'
      onChange={onChange}
      onKeyPress={onKeyPress}
      onKeyUp={onKeyUp}
      onBlur={onBlur}
      inputRef={ref}
      InputProps={{
        inputComponent: NumberFormatWrapper,
        inputProps: {
          format,
          pattern,
          thousandSeparator,
          allowNegative,
          readOnly,
          value,
          type,
          ...other,
        },
        startAdornment,
        ...InputProps,
      }}
      autoFocus={autoFocus}
      disabled={disabled}
      error={error}
      {...other}
    />
  );
};

export default NumberFormatInput;
